export const DEFAULT_PER_PAGE = 10;
export const INFINITE_SCROLL_PER_PAGE = 20;
